import { createContext } from "react";
import { VideoPlayerManager2 } from "./types";

export const VidePlayer2PContext = createContext<VideoPlayerManager2 | null>(
  null,
);
